export interface ClosAssetDTO {
  _id: string;

  name: string;

  preview_name: string;

  /** in bytes */
  size: number;

  /** Indicates if the asset has been uploaded to the cloud */
  uploaded: boolean;

  /** Indicates if the asset preview has been uploaded to the cloud */
  preview_uploaded: boolean;

  /** user who uploaded the file */
  uploader_id: string;

  presigned_url: string;

  presigned_preview_url: string;

  score: number;

  /** if the asset belongs to the "sharing" bucket */
  retouch: boolean;

  retouch_source: string;

  /** indicates if the asset is a video */
  video: boolean;

  checked: boolean;

  uploaded_at: string | null;

  reserved_at: string | null;

  created_at: string | null;
}

export interface UploadIntentionDTO {
  url: string;
  header: {
    'content-length': [string];
  };
}

export interface BinaryDetailsDTO {
  name: string;

  /** In bytes */
  size: number;

  /** Mimetype, e.g. - image/jpg */
  type: string;
}

export interface ClosAssetRegisterDTO extends BinaryDetailsDTO {
  /** see {@link ClosAssetDTO.retouch} */
  retouch: boolean;
}

export interface ClosAssetsRecordDTO {
  list: Record<ClosAssetDTO['name'], ClosAssetDTO['_id']>;
}

export enum ClosAssetDirectory {
  /** Asset captured during {@Link ClosSession} */
  sessions = 'original',

  /** Asset uploaded as a sharing attachment */
  sharing = 'retouch',

  previews = 'preview',

  videos = 'video',

  videoPreviews = 'video_preview',

  avatars = 'avatar',
}
